import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { OptionsListStore } from 'src/app/store/options-list-store';
import { DragStore } from 'src/app/store/drag-store';
import { AnswersStore } from 'src/app/store/answers-store';
import { filter, map, tap } from 'rxjs';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { GlobalStore } from 'src/app/store/global-store';
import { TostDisplayComponent } from 'src/app/shared/components/tost-display/tost-display.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { TostPositionEnum, TostTypeEnum } from 'src/app/shared/models/tostes.model';
@Component({
    selector: 'que-create-questionnaire-warp',
    imports: [CommonModule, RouterOutlet, TostDisplayComponent],
    providers: [OptionsListStore, AnswersStore, QuestionnaireStore, DragStore, MiniOperationsStore],
    //AnswersStore not use just because in user import
    templateUrl: './create-questionnaire-warp.component.html',
    styleUrls: ['./create-questionnaire-warp.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateQuestionnaireWarpComponent implements OnInit {
  #questionnaireStore = inject(QuestionnaireStore);
  questionnaireId$ = this.#questionnaireStore.questionnaireId$;
  #activeRoutes = inject(ActivatedRoute);
  #global = inject(GlobalStore)
  #router = inject(Router);
  // #location=inject(Location);
  loadingDistributed$ = toSignal(this.#questionnaireStore.loadingDistributed$);
  tostPositionEnum = TostPositionEnum;
  tostTypeEnum = TostTypeEnum;
  isTost = false;
  ngOnInit(): void {
    // this.questionnaireId$.pipe(filter(id => id != 0)).subscribe(
    //   (newId) => {
    //     const currentUrl = this.#router.url;
    //     const newUrl = currentUrl.replace(/\/\d+\//, `/${newId}/`);
    //     this.#router.navigate(
    //       [],
    //       {
    //         relativeTo: this.#activeRoutes,
    //         queryParamsHandling: 'merge',
    //         // skipLocationChange: true, // This prevents the navigation from being triggered
    //       }
    //     ).then(() => {
    //       this.#router.navigateByUrl(newUrl);
    //     });
    //   }
    // )
    const selectedId$ = this.#activeRoutes.params.pipe(
      filter(p => !isNaN(p['id'] as number)), map(p => p['id'] as number))
    this.#questionnaireStore.fetchQuestionnaireById(selectedId$)
  }

  removeTost() {
    this.isTost = true;
  }
}
